import React from "react";

export const SectionCard = ({ title, desc, right, children, testid }) => (
  <div data-testid={testid} className="bg-white border border-slate-200 rounded-lg shadow-sm p-6">
    {(title || right) && (
      <div className="flex items-start justify-between mb-4">
        <div>
          {title && <h3 className="font-display text-lg font-semibold text-slate-900">{title}</h3>}
          {desc && <p className="text-sm text-slate-500 mt-0.5">{desc}</p>}
        </div>
        {right}
      </div>
    )}
    {children}
  </div>
);

export const Field = ({ label, children, hint }) => (
  <div>
    <label className="block text-sm font-medium text-slate-700 mb-1">{label}</label>
    {children}
    {hint && <p className="text-xs text-slate-400 mt-1">{hint}</p>}
  </div>
);

export const inputCls =
  "w-full border border-slate-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm";

export const Textarea = (props) => (
  <textarea {...props} className={`${inputCls} resize-none`} />
);

export const Input = (props) => <input {...props} className={inputCls} />;
